import { Typography, Alert, Button } from '@mui/material';
import React, { useState, useEffect } from 'react';

export const ExportDataConfirmation = ({
  exportRequests,
  exportOptions,
  projects,
  exportData,
  setDisableExport,
}) => {
  const [duplicates, setDuplicates] = useState([]);
  const [duplicateRequestId, setDuplicateRequestId] = useState(null);
  const inProgressRequests = exportRequests?.filter(
    (request) => request?.status === 'requested'
  );

  const handleCheckDuplicates = () => {
    const selectedProjectIds = exportOptions?.projects;

    const duplicateRequest = inProgressRequests && inProgressRequests.find((request) => {
      const requestProjectIds = request.project_id;
      return (
        selectedProjectIds.sort().join(',') ===
        requestProjectIds.sort().join(',')
      );
    });
    if (duplicateRequest) {
      const duplicateProjectNames = selectedProjectIds
        .map((id) => projects.find((project) => project.id === id)?.name || '')
        .join(', ');

      setDuplicates(duplicateProjectNames);
      setDuplicateRequestId(duplicateRequest.id);
      setDisableExport(true);
    } else {
      setDuplicates([]);
      setDisableExport(false);
    }
  };

  useEffect(() => {
    if (exportOptions?.projects?.length > 0) {
      handleCheckDuplicates();
    } else {
      setDuplicates([]);
    }
  }, [exportOptions, exportRequests]);

  const overrideExport = () => {
    exportData('override', duplicateRequestId);
  };

  return (
    <>
      {duplicates.length > 0 ? (
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            You have ongoing export requests for the following projects:{' '}
            <strong>{duplicates}</strong>. You can either wait for them to
            complete or override the current request.
          </Typography>
          <Button
            size="small"
            color="error"
            variant="contained"
            title="Override Current Request"
            onClick={overrideExport}>
            Override Current Request
          </Button>
        </Alert>
      ) : (
        inProgressRequests.length > 0 && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>
                You have ongoing export requests for some projects.
              </strong>
            </Typography>
            <Typography variant="body2">
              You can initiate a new export for other projects without
              interrupting current requests. For projects with an active
              request, you may choose to override it.
            </Typography>
          </Alert>
        )
      )}
    </>
  );
};
